/* TechRover Theme JS — Circular orbit + 3D parallax + reveal-on-scroll */
(function(){
  const stage = document.querySelector('.tr-stage');
  const product = document.querySelector('.tr-stage__product');

  if (stage && product) {
    // Targets
    let targetTX = 0, targetTY = 0;
    let targetRX = 0, targetRY = 0;
    // Current (smoothed)
    let curTX = 0, curTY = 0;
    let curRX = 0, curRY = 0;

    const damp = 0.12;
    const orbitRadius = Math.min(82, Math.max(42, window.innerWidth * 0.055));   // px — responsive circular orbit radius
    const maxRot = 22;        // deg — stronger 3D tilt amount
    let rafId = null;

    function loop(){
      curTX += (targetTX - curTX) * damp;
      curTY += (targetTY - curTY) * damp;
      curRX += (targetRX - curRX) * damp;
      curRY += (targetRY - curRY) * damp;

      product.style.transform =
        `translate3d(${curTX}px, ${curTY}px, 0) ` +
        `rotateY(${curRX}deg) rotateX(${-curRY}deg) ` +
        `translateZ(40px)`;

      // Glow follows the orbit position
      stage.style.setProperty('--tr-glow-x', (50 + curTX * 0.8) + '%');
      stage.style.setProperty('--tr-glow-y', (50 + curTY * 0.8) + '%');

      rafId = requestAnimationFrame(loop);
    }

    function setFromPoint(clientX, clientY){
      // Compute angle from stage center to pointer
      const rect = stage.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      const dx = clientX - cx;
      const dy = clientY - cy;
      const angle = Math.atan2(dy, dx);

      const distance = Math.min(1, Math.hypot(dx, dy) / Math.max(rect.width, rect.height) * 2);

      // Place the product on a smooth circular orbit that follows cursor/finger direction
      targetTX = Math.cos(angle) * orbitRadius * distance;
      targetTY = Math.sin(angle) * orbitRadius * distance;

      // Tilt the device toward the cursor for a stronger 3D feel
      targetRX = Math.cos(angle) * maxRot * distance;
      targetRY = Math.sin(angle) * maxRot * distance;
    }

    // Desktop — cursor tracking
    window.addEventListener('mousemove', (e) => {
      setFromPoint(e.clientX, e.clientY);
    }, { passive: true });

    // Mobile — finger tracking
    window.addEventListener('touchmove', (e) => {
      if (!e.touches || !e.touches[0]) return;
      setFromPoint(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });

    // Auto idle orbit — gentle continuous circular motion when no input
    let lastInput = Date.now();
    ['mousemove','touchmove','touchstart'].forEach(ev =>
      window.addEventListener(ev, () => { lastInput = Date.now(); }, { passive: true })
    );
    let idleAngle = 0;
    setInterval(() => {
      if (Date.now() - lastInput > 2000) {
        idleAngle += 0.02;
        targetTX = Math.cos(idleAngle) * orbitRadius;
        targetTY = Math.sin(idleAngle) * orbitRadius;
        targetRX = Math.cos(idleAngle) * maxRot * 0.6;
        targetRY = Math.sin(idleAngle) * maxRot * 0.6;
      }
    }, 30);

    // Mobile — gyroscope fallback
    window.addEventListener('deviceorientation', (e) => {
      if (Date.now() - lastInput < 1500) return;
      if (e.gamma === null || e.beta === null) return;
      const gx = Math.max(-30, Math.min(30, e.gamma)) / 30;
      const gy = Math.max(-30, Math.min(30, (e.beta - 45))) / 30;
      const angle = Math.atan2(gy, gx);
      targetTX = Math.cos(angle) * orbitRadius;
      targetTY = Math.sin(angle) * orbitRadius;
      targetRX = gx * maxRot;
      targetRY = gy * maxRot;
    });

    // Pause loop when off-screen
    const visibilityObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !rafId) loop();
        else if (!entry.isIntersecting && rafId) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
      });
    }, { threshold: 0 });
    visibilityObserver.observe(stage);

    loop();

    // Floating particles
    const particleHost = document.querySelector('.tr-stage__particles');
    if (particleHost) {
      for (let i = 0; i < 22; i++) {
        const p = document.createElement('span');
        p.style.left = Math.random()*100 + '%';
        p.style.top = Math.random()*100 + '%';
        p.style.animation = `tr-pulse ${3+Math.random()*4}s ease-in-out infinite`;
        p.style.animationDelay = (Math.random()*3) + 's';
        particleHost.appendChild(p);
      }
    }
  }

  // Reveal on scroll
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.tr-fade-up').forEach(el => io.observe(el));
})();

/* Site-wide cursor glow follow */
(function(){
  var glow = document.querySelector('.tr-cursor-glow');
  if(!glow) return;
  var x = window.innerWidth/2, y = window.innerHeight/2;
  var tx = x, ty = y;
  function loop(){
    x += (tx - x) * 0.18;
    y += (ty - y) * 0.18;
    glow.style.transform = 'translate3d(' + (x - 260) + 'px,' + (y - 260) + 'px,0)';
    requestAnimationFrame(loop);
  }
  window.addEventListener('mousemove', function(e){
    tx = e.clientX; ty = e.clientY;
    glow.classList.add('is-active');
  }, { passive: true });
  window.addEventListener('mouseleave', function(){ glow.classList.remove('is-active'); });
  loop();
})();
